/*--------------------------------------------------------------
# Custom scripts for Awards block
--------------------------------------------------------------*/

const awardSlider = document.querySelectorAll('.awards .swiper');
const awardSliderNext = document.querySelectorAll('.award-swiper-next');
const awardSliderPrev = document.querySelectorAll('.award-swiper-prev');

for( i = 0; i < awardSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    awardSlider[i].classList.add('swiper-' + i);
    awardSliderNext[i].classList.add('award-swiper-next-' + i);
    awardSliderPrev[i].classList.add('award-swiper-prev-' + i);

    var initAwardSlider = new Swiper('.awards .swiper-' + i, {
        simulateTouch: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        loop: false,
        navigation: {
            nextEl: '.award-swiper-next-' + i,
            prevEl: '.award-swiper-prev-' + i,
        },
        breakpoints: {
            575: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            }
        }
    });
}
